import { FC, useContext } from 'react';

import { ELanguage, H3, IDropdownItem, Select } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';

import s from './LanguageControl.module.scss';

export const LanguageControl: FC = () => {
  const { t, lang, setLang } = useContext(LocalizationContext);

  const options: IDropdownItem<ELanguage>[] = [
    { value: ELanguage.RU, title: 'Русский' },
    { value: ELanguage.EN, title: 'English' },
    { value: ELanguage.VI, title: 'Tiếng Việt' },
    { value: ELanguage.ES, title: 'Español' },
    { value: ELanguage.KK, title: 'Қазақша' },
    { value: ELanguage.UZ, title: 'O‘zbekcha' },
    { value: ELanguage.KY, title: 'Кыргыз' },
    { value: ELanguage.AZ, title: 'Azərbaycan' },
    { value: ELanguage.PT, title: 'Português' },
    { value: ELanguage.FR, title: 'Français' },
    { value: ELanguage.TR, title: 'Türk', disabled: true },
    { value: ELanguage.DE, title: 'Deutsch', disabled: true },
  ];

  return (
    <div className={s.container}>
      <H3>{t('settings.billing.vote.lang.title')}</H3>
      <div className={s.select_block}>
        <Select
          className={s.select}
          name="billingLanguage"
          options={options}
          value={lang}
          onChange={(value) => {
            if (value) {
              setLang(value);

              if (value !== lang) {
                return notification.info({
                  t,
                  type: 'success',
                  title: t('setting.updated'),
                  dismiss: 5,
                });
              }
            }
          }}
          bordered
          disableClear
        />
      </div>
    </div>
  );
};
